module.exports = __webpack_public_path__ + "static/img/tools_bg02.6a30d3e9.png";